/**
 * The Mutation types
 * @type String
 */

export const SET_DECKS = 'set-decks'

/**
 * The Mutations
 * @type { Object }
 */
export default {
	[SET_DECKS]: (state, data) => {
		state.decks = data;
	},

};


// WEBPACK FOOTER //
// ./src/store/decks/mutations.js